module.exports = __webpack_public_path__ + "static/Tracking-526327198a9f6869bbcf16b44791a59c.svg";